






import { Vue, Component } from "vue-property-decorator";
// import Top from "@/components/journey/top.vue";
// import Bottom from "@/components/journey/bottom.vue";
import JoruneySwiper from "@/components/swiper/index.vue";
import swiperData from "./data";
@Component({
  components: {
    JoruneySwiper
  }
})
export default class Journey extends Vue {
  banner = swiperData;
}
